export interface Size {
  width: number
  height: number
}

export interface Point {
  x: number
  y: number
}

export interface Rect extends Point, Size {}

export interface AspectRatio {
  w: number
  h: number
}

export interface ViewTransform {
  scale: number
  offsetX: number
  offsetY: number
}

export interface ZoomLimits {
  minScale: number
  maxScale: number
}

export enum Handle {
  TopLeft = 'top-left',
  Top = 'top',
  TopRight = 'top-right',
  Right = 'right',
  BottomRight = 'bottom-right',
  Bottom = 'bottom',
  BottomLeft = 'bottom-left',
  Left = 'left',
}
